import { useEffect, useState } from 'react';
import Experiments from '@alltrails/shared/types/Experiments';
import useSelector from '../../../hooks/useSelector';
import { isIos } from '../utils';

const useInstallAOTYExperiment = () => {
  const flagKey = 'web-growth-rm-mweb-appinstall-visual';
  const [activeExperiment, setActiveExperiment] = useState<Experiments[typeof flagKey]>();
  const experiment = useSelector(state => state.experiments?.[flagKey]);

  useEffect(() => {
    if (experiment?.value && isIos()) {
      window.amplitude.getInstance().logEvent('$exposure', { flag_key: flagKey, variant: experiment.value });
      setActiveExperiment(experiment);
    }
  }, [experiment]);

  return activeExperiment;
};

export default useInstallAOTYExperiment;
